var React = require('react');

function WorkshopHd (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31,58.9c-0.3,0-0.6-0.1-0.9-0.2L11,48.1c-0.6-0.3-1-0.9-1-1.6v-7.9c0-0.7,0.3-1.3,0.9-1.6c0.6-0.3,1.3-0.3,1.8,0l17.7,9.8\n\th0.8L49.1,37c0.6-0.3,1.3-0.3,1.8,0c0.6,0.3,0.9,0.9,0.9,1.6v7.9c0,0.7-0.4,1.3-1,1.6L31.9,58.7C31.6,58.8,31.3,58.9,31,58.9z\n\t M13.8,45.4L31,54.9l17.2-9.5v-3.7l-15.4,8.5c-0.3,0.2-0.6,0.2-0.9,0.2h-1.8c-0.3,0-0.6-0.1-0.9-0.2l-15.4-8.5V45.4z M62.1,46.5\n\th-2.3c-1,0-1.9-0.8-1.9-1.9V26.9L57,26.3L31.9,40.2c-0.6,0.3-1.2,0.3-1.8,0L1,24.4c-0.6-0.3-1-0.9-1-1.6s0.4-1.3,1-1.6L30.1,5.3\n\tc0.6-0.3,1.2-0.3,1.8,0L63,22.2c0.6,0.3,1,0.9,1,1.6v20.8C64,45.6,63.2,46.5,62.1,46.5z M5.7,22.8L31,36.5l25-13.8L31,9.1L5.7,22.8z\n\t","fill":"currentColor"}));
}

WorkshopHd.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 64 64","style":{"enableBackground":"new 0 0 64 64"},"xmlSpace":"preserve"};

module.exports = WorkshopHd;

WorkshopHd.default = WorkshopHd;
